import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation";
import React from "react";

/**
 * Dynamically load translation files pertaining to the jobs module.
 * @return {*}
 */
export default function useTranslationJobs() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/jobs.json'),
    'fr': import('./locales/fr/jobs.json')
  }), []);

  return useModuleTranslation('jobs', imports);
}
